module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav"
  }, [(_vm.showDown && _vm.showLabel && _vm.index == 0 && !_vm.isxiaoxiong) ? _c('div', {
    staticClass: "download dataReport",
    attrs: {
      "data-place": "34"
    },
    on: {
      "click": _vm.loadDown
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../img/dating/app.png")
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_vm._v("下载")]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.closeLabel
    }
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "describ"
  }, [_c('p', [_vm._v("更精彩 更清晰 更流畅")]), _vm._v(" "), _c('span', [_vm._v("进入APP直播间获得更多体验")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27bbb4b0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dating/navBottom.vue
// module id = 117
// module chunks = 0